import * as React from 'react';
import { ErrorState } from './ErrorState';

interface State {
  error: Error | null;
}

export class RootErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Hook a proper error tracker (e.g. Sentry) here in Slice A-3.
    console.error('[admin-panel] Unhandled error', error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-full items-center justify-center bg-background px-4">
          <div className="w-full max-w-lg">
            <ErrorState
              title="Something broke"
              description={this.state.error.message || 'An unexpected error prevented this page from rendering.'}
              actionLabel="Reload"
              onAction={() => window.location.reload()}
            />
            <div className="mt-2 text-center">
              <button
                type="button"
                onClick={this.reset}
                className="text-xs text-muted-foreground underline hover:text-foreground"
              >
                Try again without reloading
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
